export function getOnlyFirstWord(text: string) {
	return text.split(' ')[0];
}
